import { Input, InputAdornment, useMediaQuery } from "@mui/material";
import { useRecoilValue } from "recoil";
import { scaleValue } from "../../atoms";

function ZoomValueInput() {
  const scale = useRecoilValue(scaleValue);
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Input
      id="percent"
      endAdornment={<InputAdornment position="end">%</InputAdornment>}
      sx={{
        width: isMobile ? "100px" : "60px",
        marginRight: isMobile ? 0 : 2,
        minWidth: isMobile ? "100px" : "60px",
      }}
      value={Math.round((scale * 100) / 10) * 10}
      disabled
    />
  );
}

export default ZoomValueInput;
